import 'aws-sdk/dist/aws-sdk';

import { Injectable } from '@angular/core';

import { Credentials } from '../aws/credentials';

@Injectable()
export class AwsSdk {

    constructor() {
        window['AWS'].config.maxRetries = 10;
        window['AWS'].config.correctClockSkew = true;
        window['AWS'].config.update({ retryDelayOptions: { base: 1000 } });
    }

    getTempCredentials(email: string, roleArn: string, cognitoToken: string): Promise<any> {
        let sts = new window['AWS'].STS();
        let sessionName = `${email}_role_session`;
        let params = {
            RoleArn: roleArn,
            RoleSessionName: sessionName,
            WebIdentityToken: cognitoToken
        };
        let request = sts.assumeRoleWithWebIdentity(params);

        request.on('retry', (response: any) => {
            // this resource is not yet available, wait 10 seconds to get it again
            if (response.httpResponse.statusCode === 403 && response.error) {
                response.error.retryable = true;   // retry this error
            }
        });

        return request.promise();
    }

    renewCredentials(email: string, roleArn: string, credentials: Credentials): Promise<any> {
        let sts = new window['AWS'].STS({
            accessKeyId: credentials.accessKeyId,
            secretAccessKey: credentials.secretAccessKey,
            sessionToken: credentials.sessionToken
        });
        let sessionName = `${email}_role_session`;
        let params = {
            RoleArn: roleArn,
            RoleSessionName: sessionName,
        };

        let retries = 2;
        let request = sts.assumeRole(params);

        request.on('retry', (response: any) => {
            // this resource is not yet available, wait 10 seconds to get it again
            if (response.httpResponse.statusCode === 403 && response.error) {
                if (retries > 0) {
                    response.error.retryable = true;   // retry this error
                    retries--;
                }
                else {
                    response.error.retryable = false;
                }
            }
        });

        return request.promise();
    }

}



// WEBPACK FOOTER //
// ./src/app/aws/sdk.ts